import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartHistogram = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-chart-histogram",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 3v18h18" }),
		/* @__PURE__ */ _jsx("path", { d: "M20 18v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 16v5" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 13v8" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 16v5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 11c6 0 5 -5 9 -5s3 5 9 5" })
	]
});
const ForwardRef = forwardRef(SvgChartHistogram);
export default ForwardRef;
